module.exports = __webpack_public_path__ + "static/media/hubs5.1eb87632.png";